import { render, staticRenderFns } from "./PolicyTable.vue?vue&type=template&id=4d3d32b0"
import script from "./PolicyTable.vue?vue&type=script&lang=js"
export * from "./PolicyTable.vue?vue&type=script&lang=js"
import style0 from "./PolicyTable.vue?vue&type=style&index=0&id=4d3d32b0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports